import React, { Component } from 'react';
import RoutingConstants from 'lib/RoutingConstants';
import { get } from 'lib/api';
import Loader from 'lib/loader';

import history from '../../history'



class UpgradePlan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // reminder: props.reminder,
      display: props.display || 'block',
      zIndex: 1,
      page: props.page,
      subscriptionPlan: props.subscriptionPlan || [] ,
      dayDates: props.dayDates,
      loadData: true
    };

  }
  
  componentDidMount() {
    this.getPlans();
    if (this.props.zIndex === 1) {
      localStorage.setItem('reminder','true') 
    } 
  }

  async getPlans() {
    const url = RoutingConstants.getSubscriptionPlan;
    await get(url).then((response) => {
      const result = response.result;
      this.setState({ subscriptionPlan: result, loadData: false, zIndex:9999 });
    }).catch(() => {
      this.setState({ loadData: false})
      this.props.onClose()
    });
  }

  // eslint-disable-next-line
  goToPay(planId, planName, amount) {
    amount = `$${amount}`
    const { dayDates } = this.state
    history.push('/billingPlan',{planId, planName, amount, dayDates, ...this.state, path:'dash'})
  }
  
  subscriptionDetail() {
    const { subscriptionPlan , page} = this.state
    const id = localStorage.getItem('email')
    window.analytics.track('Billing Popup Viewed', {
      page,
      id
    });
    
    return(
      <div className="popup-plans">
        {
          subscriptionPlan.length > 0 &&
          subscriptionPlan.map(plan=>{
            plan.discount_detail = plan.discount_detail === null ? 0 : plan.discount_detail
            const amount = (plan.total_price / 100)
            const visibility = plan.discount_detail !== 0 ? 'visible' : 'hidden'
            return(
              <div className="plan_prc" key={plan}>
                <div className="plan-green-box data-hj-whitelist">
                  <button onClick={()=>this.goToPay(plan.plan_id,plan.plan_name, amount)}>
                    {plan.plan_name}<span>${amount}</span>
                  </button>
                  
                </div>
                <p><strong style={{visibility}}>{plan.discount_detail}</strong></p>
                <p className="mb-hide" style={{textTransform:'capitalise'}}>Renews {plan.renewal_period}</p>
                <p className="mb-only">{plan.renewal_period}</p>
              </div>
            )
          })
        }
      </div>
    )
  }

  //  eslint-disable-next-line
  onClose() {
    return false;
  }

  render() {
    const { display, subscriptionPlan } = this.state

    const {
      loadData, zIndex
    } = this.state;

    return (
      <div>
        {
          loadData &&
        <div className="loading">
          <Loader />
          <div className="modal-backdrop fade in" />
        </div>
        }
        <div id="upgrade-popup" className="upgrade-popup modal fade in" style={{ display, zIndex, marginTop:'-54px' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="popup-hdng">
                
                <div>
                  <h2 className="mb-only">Your Free Trial has Expired </h2>
                  {/* <button type="button" className="close" onClick={() => this.onClose()}>
                    <i className="fa fa-close mb-only" />
                    <svg
                      className="mb-hide"
                      width="20px"
                      height="20px"
                      viewBox="0 0 20 20"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                    >
                      <desc>Created with Sketch.</desc>
                      <defs />
                      <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                        <g id="Icon-/-Delete-(White)" fill="#FFFFFF" fillRule="nonzero">
                          <g id="noun_1054717">
                            <path d="M10,0.104166667 C4.54166667,0.104166667 0.104166667,4.54166667 0.104166667,10 C0.104166667,15.4583333 4.54166667,19.8958333 10,19.8958333 C15.4583333,19.8958333 19.8958333,15.4583333 19.8958333,10 C19.8958333,4.54166667 15.4583333,0.104166667 10,0.104166667 Z M10,18.1458333 C5.5,18.1458333 1.85416667,14.5 1.85416667,10 C1.85416667,5.5 5.5,1.85416667 10,1.85416667 C14.5,1.85416667 18.1458333,5.5 18.1458333,10 C18.1458333,14.5 14.5,18.1458333 10,18.1458333 Z" id="Shape" />
                            <path d="M14.7708333,6.70833333 L13.2916667,5.22916667 C13.125,5.0625 12.875,5.0625 12.7083333,5.22916667 L10,7.9375 L7.29166667,5.22916667 C7.125,5.0625 6.875,5.0625 6.70833333,5.22916667 L5.22916667,6.70833333 C5.0625,6.875 5.0625,7.125 5.22916667,7.29166667 L7.9375,10 L5.22916667,12.7083333 C5.0625,12.875 5.0625,13.125 5.22916667,13.2916667 L6.70833333,14.7708333 C6.875,14.9375 7.125,14.9375 7.29166667,14.7708333 L10,12.0625 L12.7083333,14.7708333 C12.875,14.9375 13.125,14.9375 13.2916667,14.7708333 L14.7708333,13.2916667 C14.9375,13.125 14.9375,12.875 14.7708333,12.7083333 L12.0625,10 L14.7708333,7.29166667 C14.9375,7.125 14.9375,6.875 14.7708333,6.70833333 Z" id="Shape" />
                          </g>
                        </g>
                      </g>
                    </svg>
                  </button>
                */}
                </div>
                <h2 className="mb-hide">Join Now and Stick with Healthy Eating </h2>
                
              </div>
              <div className="upgrade-popup-cntnt">
                {/* <h5>Select a Plan to Continue Your Membership</h5> */}
                <p className="mb-hide">
                  Your free trial period has expired. In order to keep using your Prep Day account 
                  you’ll need to upgrade to a paid plan from one of the options below.
                </p>
                <p className="mb-only">Join Now and Stick with Healthy Eating </p>
                <ul>
                  <li> Keep access to all of your meal plans </li>
                  <li> Try new recipes that are constantly being added to our library </li>
                  <li> Cancel anytime, no problem </li>
                </ul>
              </div>
              { subscriptionPlan.length > 0 &&
                this.subscriptionDetail()
              }
              <div className="popup-ftr">
                <p> Contact support@mealplanninja.com if you have any questions. </p>
              </div>
                
              
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default UpgradePlan;



// WEBPACK FOOTER //
// ./src/components/billingDetails/UpgradePlan.js